import React from "react";


import { NavLink } from "react-router-dom";

import { Col } from "react-bootstrap";


import Logo from "@Assets/Logo.png";


export const ApplicationHeaderLogo:React.FC = () => {

    return (
        <Col xs={5} lg={2} xl={'auto'} className={'app-header__service-logo'}>

            <NavLink to={'/'} title={'What you’re owed, on autopilot.'} className={'app-header__service-logo__home-page-link'}>
                <img src={Logo} alt={`Qyvo`} />
            </NavLink>

        </Col>
    );

};


export default ApplicationHeaderLogo;
